import { render, staticRenderFns } from "./ProyeccionTable.vue?vue&type=template&id=71df5f32&"
import script from "./ProyeccionTable.vue?vue&type=script&lang=js&"
export * from "./ProyeccionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports